export default () => ({
  user: null,
  groups: [],
  emailAlerts: [],
  trackedBacktests: [],
  insiderAlerts: [],
  whaleAlerts: [],
  limit: 5,
  isTeamMember: false,
  isSubscriber: false,
  isProSubscriber: false,
  isEnterpriseSubscriber: false,
  tradingModels: [],
  socket_consumer: null,
  socket_channel: null,
  socket_callback: null,
  trading_model_update: null,
  status_update_snackbar: false
})
